// extracted by mini-css-extract-plugin
export default {"container":"styles_container__IDRJH","histogramContainer":"styles_histogramContainer__Q15dx"};